import {getAssistantWorkInfo} from './assistant-work-info.js';
import {getHomeworkList} from './service-assistant';

/**
 * @returns {boolean}
 *
 * 判断是否为最后一份作业：
 * 条件一： 若当前是 homeworkIdList 最后一条，且 homeworkIdList[0] 已批改，则判断当前为最后一份
 * 条件二： 若当前不是 homeworkIdList 最后一条，且 下一条 已批改，则判断当前为最后一份
 *
 * 原因：从作业列表第一条跳转进IDE，适用条件一（如第一份作业略过，也适用条件二）；从作业列表第 n 条跳转进IDE，适用条件二
 */
const isLastHomework = () => {
    const assistantWorkInfo = getAssistantWorkInfo();
    if (assistantWorkInfo.homeworkIdList) {
        const isLastHomework = assistantWorkInfo.homeworkIdList.length - 1 === assistantWorkInfo.currentPageIndex; //eslint-disable-line
        const hasFirstHomework = assistantWorkInfo.homeworkIdList[0];
        const hasNextHomework = assistantWorkInfo.homeworkIdList[assistantWorkInfo.currentPageIndex + 1];
        const hasOnlyOneHomework = assistantWorkInfo.homeworkIdList.length === 1;

        if (hasOnlyOneHomework || (isLastHomework && !hasFirstHomework) || (!isLastHomework && !hasNextHomework)) {
            return true;
        }
    } else {
        return true;
    }
};

// 获取作业列表
const getHomeworkInfo = homeworkId => (
    getHomeworkList(homeworkId)
        .then(data => {
            const homeworkListInfo = [];
            data.forEach(value => {
                const item = {
                    homeworkId: value.id,
                    homeworkUrl: value.url,
                    className: value.class && value.class.name,
                    courseLevel: value.course && value.course.level,
                    sectionName: value.section && value.section.name,
                    title: value.title,
                    nickname: value.user && value.user.nickname,
                    answerUrl: value.lesson && value.lesson.answer,
                    lessonId: value.lessonId,
                    correctStatus: value.correctStatus
                };
                homeworkListInfo.push(item);
            });
            return homeworkListInfo;
        })
);

// 跳转到下一份作业
const goAeadToNextHomework = () => {
    const assistantWorkInfo = getAssistantWorkInfo();
    // 当前作业是列表中最后一份
    if (assistantWorkInfo.homeworkIdList.length - 1 === assistantWorkInfo.currentPageIndex) {
        // 检查列表中第一份是否被批改过, 若未被批改则从头继续批改
        // 这是因为助教可能是从第列表的第n份作业跳转进来，最后应该跳转回开头批改前面的作业
        if (assistantWorkInfo.homeworkIdList[0]) {
            assistantWorkInfo.currentPageIndex = 0;
        }
    } else if (assistantWorkInfo.homeworkIdList[assistantWorkInfo.currentPageIndex + 1]) {
        assistantWorkInfo.currentPageIndex += 1;
    }

    const storage = window.sessionStorage;
    storage.setItem('assistantWorkInfo', JSON.stringify(assistantWorkInfo));

    const nextHomeworkId = assistantWorkInfo.homeworkIdList[assistantWorkInfo.currentPageIndex];
    const getList = getHomeworkInfo(nextHomeworkId);
    getList.then(
        nextInfo => {
            const info = nextInfo[0];
            window.location.replace(`//${location.host}/?mode=assistant&url=${info.homeworkUrl}&homeworkId=${info.homeworkId}&className=${info.className}&courseLevel=${info.courseLevel}&sectionName=${info.sectionName}&title=${info.title}&nickname=${info.nickname}&answerUrl=${info.answerUrl}&lessonId=${info.lessonId}&correctStatus=${info.correctStatus}`); //eslint-disable-line
        }
    );
};

// 从作业列表中 删除已批改完成的作业, 并跳转到下一份
const checkWorkAndGoAeadToNext = () => {
    const assistantWorkInfo = getAssistantWorkInfo();
    delete assistantWorkInfo.homeworkIdList[assistantWorkInfo.currentPageIndex];
    // 若当前是最后一份作业，则批改完成后弹出提示
    if (isLastHomework()) {
        confirm('本批作业批改完毕，请回到助教列表重新选择'); //eslint-disable-line
    } else {
        goAeadToNextHomework();
    }
};

export {
    isLastHomework,
    getHomeworkInfo,
    goAeadToNextHomework,
    checkWorkAndGoAeadToNext
};
